module.exports = __webpack_public_path__ + "img/reccord_button.915ab550.svg";